import React from 'react';
import { INITIAL_STATE } from './LandingState.types';
export const LandingStateContext = React.createContext({
    state: INITIAL_STATE,
    dispatch: () => { },
    reset: () => { },
});
